// extracted by mini-css-extract-plugin
module.exports = {"social-link-list":"_2NHs2"};